import React, { useEffect, useState } from "react";
import { Datagrid, DateField, List, NumberField } from "react-admin";
import { Box, Card, CardHeader, Divider } from "@mui/material";
import { useParams } from "react-router-dom";
import { HistoryList } from "../HistoryList";
import UserHandler from "../../react-admin/providers/handlers/UserHandler";
import { LogsList } from "../LogsList";
import { Message } from "../../models";

interface Thread {
  id: string;
  last_activity: string;
  message_count: number;
}

interface User {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
}

export const ThreadList = () => {
  const { userId } = useParams();
  const [selected, setSelected] = useState<Thread | undefined>();
  const [selectedMessage, setSelectedMessage] = useState<Message | undefined>();
  const [user, setUser] = useState<User | undefined>();

  useEffect(() => {
    UserHandler.getOneHandler("users", { id: userId || "" }).then((res) => {
      setUser(res.data);
    });
  }, [userId]);

  const isLogShown = selected && selectedMessage && userId;
  const isHistoryShown = selected && userId;
  console.log(selectedMessage);
  return (
    <>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "380px 1fr" },
          gap: 2,
          height: !isLogShown ? "calc(100vh - 112px)" : "calc(50vh - 112px)",
        }}
      >
        <Card sx={{ overflow: "scroll" }}>
          <CardHeader title="Threads" />
          <Divider />
          <List
            title={
              <span>
                Threads of{" "}
                <strong>
                  {user?.first_name} {user?.last_name} ({user?.email})
                </strong>
              </span>
            }
            resource={`/admin/users/${userId}/threads`}
            pagination={false}
            exporter={false}
          >
            <Datagrid
              title={""}
              rowSx={(record) => ({
                backgroundColor:
                  record.id === selected?.id
                    ? "#e0ffe0" // light green for completed
                    : "inherit", // default
              })}
              rowClick={(_, __, record) => {
                setSelected(record as Thread);
                setSelectedMessage(undefined);
                // Return undefined so RA won’t navigate
                return undefined as unknown as any;
              }}
              bulkActionButtons={false}
              sx={{
                "& .RaDatagrid-row": {
                  cursor: "pointer",
                },
                // highlight selected row
                "& .RaDatagrid-row[data-id]": {
                  // nothing
                },
                "& .RaDatagrid-row[data-id].selected": {
                  fontWeight: 600,
                },
              }}
              // rowClassName={(id) => (id === selectedId ? 'selected' : '')}
            >
              <DateField
                source="last_activity"
                label="Datetime"
                sortable={false}
              />
              <NumberField
                source="message_count"
                label="Message Count"
                sortable={false}
              />
            </Datagrid>
          </List>
        </Card>
        {isHistoryShown && (
          <Card sx={{ overflow: "scroll" }}>
            <CardHeader title="History" />
            <Divider />
            <HistoryList
              threadId={selected.id}
              userId={userId}
              setSelected={setSelectedMessage}
            ></HistoryList>
          </Card>
        )}
      </Box>
      {isLogShown && (
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr" },
            gap: 2,
            height: "calc(50vh)",
          }}
        >
          <Card sx={{ overflow: "scroll" }}>
            <CardHeader title="Details" />
            <Divider />
            <LogsList
              runId={selectedMessage.additional_kwargs?.run_id}
              userId={userId}
              date={selectedMessage?.response_metadata?.timestamp}
              message={selectedMessage}
            ></LogsList>
          </Card>
        </Box>
      )}
    </>
  );
};
